import { Component } from "react";
import PropTypes from "prop-types";
import L from "leaflet";
import styles from "./VectorLayerObservadors.module.css";
import { COLOR_PUNT_OBSERVADOR } from "../../constantsObservacions";

/**
 * Si el texte rebut per parametre es null retorna un "-", sino retornar el mateix paràmetre
 * @param {String} text
 * @return {String}
 */
const getText = text => {
  return typeof text !== "undefined" && text !== null ? text : "-";
};

// Mida del circle (icona segons el zoom de visualització
const calculateRadius = zoom => {
  // MAD: modifico el cálcul del circle
  return Math.pow(2, 10 - zoom) * 900;
};

class VectorLayer extends Component {
  constructor(props) {
    super(props);

    const { active, lMap, lControl, name } = props;
    this.layerGroup = L.layerGroup();
    this.name = name;

    if (active) {
      lMap.addLayer(this.layerGroup);
    }

    //Si no tiene la propiedad lControl no se mostara en la control de capas
    if (lControl) {
      lControl.addOverlay(this.layerGroup, name);
    }

    //Es modifica el radi dels markers segons el nivell de zoom. Si no es posa al fer zoom es veuen els cercles grans
    lMap.on("zoomend", () => {
      var currentZoom = lMap.getZoom();

      const radius = calculateRadius(currentZoom);

      lMap.eachLayer(() => {
        this.layerGroup.eachLayer(layer => {
          layer.setRadius(radius);
        });
      });
    });
  }

  pintarDades = () => {
    const { dades, lMap } = this.props;
    if (
      typeof dades === "undefined" ||
      dades === null ||
      !dades ||
      !Array.isArray(dades)
    ) {
      this.layerGroup.clearLayers();
      return;
    }
    this.layerGroup.clearLayers();
    const radius = calculateRadius(lMap.getZoom());

    dades.forEach(observacio => {
      const nomObservador = `${getText(observacio.nom)} ${getText(
        observacio.cognom1
      )}`;

      const textObservador =
        observacio.usuariNom +
        (observacio.permisMostrarNom ? " - " + nomObservador : "");

      let textEspecies = "<ul>";
      observacio.nomsEspecies.forEach(especie => {
        textEspecies += "<li>" + especie + "</li>";
      });
      textEspecies += "</ul>";

      L.circle([observacio.latitud, observacio.longitud], {
        radius: radius,
        color: COLOR_PUNT_OBSERVADOR,
        fillColor: COLOR_PUNT_OBSERVADOR,
        name: "Observador",
        fillOpacity: 1,
        opacity: 0.8
      })
        .addTo(this.layerGroup)
        .bindPopup(
          `
            <div class=${styles.panelTitle}><strong> ${textObservador}</strong></div>
            <div class=${styles.panel}>
            <strong>Espècies:</strong><span>${textEspecies}</span>
            </div>
            `,
          { closeButton: false }
        );
    });
  };

  componentDidMount() {
    this.pintarDades();
  }

  //Afagar les noves dades i pintarles al mapa
  componentDidUpdate() {
    this.pintarDades();
  }

  render() {
    return null;
  }
}

VectorLayer.propTypes = {
  active: PropTypes.bool,
  lMap: PropTypes.object,
  lControl: PropTypes.object,
  name: PropTypes.string,
  dades: PropTypes.array,
  iconFunc: PropTypes.func
};

export default VectorLayer;
